// extracted by mini-css-extract-plugin
export default {"layout":"login_layout__EGgJS","container":"login_container__+fja+","title":"login_title__TLfXs","mainTitle":"login_mainTitle__+fao1","imageContainer":"login_imageContainer__3xZen"};